import { GameLogItemProps } from "../GameLogItem/types";
import { TeamReportList } from "../../util/Requests";

export const enrichGameLogWithIds = (
  gameLog: GameLogItemProps[],
  reportList?: TeamReportList,
  teamAbbrev?: string,
  availableGameIds: string[] = []
): GameLogItemProps[] =>
  gameLog.map((game) => {
    const matchingReport = reportList?.game.find(
      (report) => report.gameInfo.date === game.date
    );
    if (!matchingReport) return game;
    const gameId = matchingReport.gameInfo.gameId;
    return {
      ...game,
      gameId,
      teamAbbrev,
      reportAvailable: availableGameIds.includes(gameId),
    };
  });
